import React, { useEffect, useRef, useState } from 'react';

const CollapsibleDiv = ({ children, isOpen, minHeight=0, maxHeight=null, style={} }) => {
    const contentRef = useRef(null);

    const [maxHeightState, setMaxHeightState] = useState(minHeight);

    useEffect(() => {
        if (isOpen) {
            // setMaxHeightState(contentRef.current?.scrollHeight || maxHeight);
            setMaxHeightState(maxHeight);
        } else {
            setMaxHeightState(minHeight);
        }
    }, [isOpen, maxHeight, minHeight]);

    const handleTransitionEnd = (e) => {
        if (e.propertyName === 'max-height' && isOpen && maxHeightState === maxHeight) {
            setMaxHeightState('none');
        }
    };

    return (
        <div
            className={`mb-6 p-4${isOpen ? '' : ''}`}
            ref={contentRef}
            onTransitionEnd={handleTransitionEnd}
            style={{
                overflow: 'hidden',
                maxHeight: maxHeightState === "none" ? undefined : `${maxHeightState}px`,
                transition: maxHeightState === "none" ? undefined : 'max-height 0.5s ease, padding 0.5s ease',
                ...style
            }}
        >
            {children}
        </div>
    );
};

export default CollapsibleDiv;
